/**
 * SpeakableSpecification type
 * DOC: https://schema.org/SpeakableSpecification
 */

export default ({
  cssSelector,
  xpath
}) => ({
  '@type': 'SpeakableSpecification',
  ...((xpath === null || xpath === void 0 ? void 0 : xpath.length) > 0 && {
    xpath
  }),
  ...((cssSelector === null || cssSelector === void 0 ? void 0 : cssSelector.length) > 0 && {
    cssSelector
  })
});